<template>
  <div
    class="sf-layer-rounded sf-layer-white sf-scrollbar tw-overflow-hidden"
    :class="{ 'sf-pad-2': failed }"
  >
    <SfBannerInline v-if="failed" :variant="bannerVariants.warning">
      <template #title>
        <span class="tw-font-semibold">
          {{ I18n.t('reconciliation_review.item_error') }}
        </span>
      </template>
    </SfBannerInline>
    <template v-else>
      <WorkflowReviewLoader
        v-if="loading"
        data-testid="review-item-solid-loader"
      />
      <div ref="mountNode" data-testid="review-item-solid" />
    </template>
  </div>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue'
import { mountSolidTemplate } from '@app/adapters/solid/mount-solid-template'
import SfBannerInline from '@app/shared/vue/components/sf-banner/sf-banner-inline.vue'
import { bannerVariants } from '@app/shared/types/banner'
import useI18n from '@app/shared/vue/composables/use-I18n'
import type { SolidTemplateBoot } from '@app/shared/types/sf-data'
import WorkflowReviewLoader from './workflow-review-loader.vue'

const I18n = useI18n()

const props = defineProps<{ solidTemplate: SolidTemplateBoot }>()
const mountNode = ref<HTMLElement | null>(null)
const loading = ref(true)
const failed = ref(false)

const abortController = new AbortController()

onMounted(async () => {
  if (!mountNode.value) {
    return
  }

  const result = await mountSolidTemplate({
    boot: props.solidTemplate,
    el: mountNode.value,
    signal: abortController.signal,
    refreshData: false,
  })

  if (result === 'mounted') {
    loading.value = false
  }

  if (result === 'failed') {
    failed.value = true
  }
})

onUnmounted(() => {
  abortController.abort()
})
</script>
